import { useMemo } from "react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

const TZ = "Asia/Ho_Chi_Minh";
const THU_VI = [
  "Chủ nhật",
  "Thứ hai",
  "Thứ ba",
  "Thứ tư",
  "Thứ năm",
  "Thứ sáu",
  "Thứ bảy",
];
const THU_VI_SHORT = ["CN", "T2", "T3", "T4", "T5", "T6", "T7"];

const BoltDateTabs = ({ activeTab, onChange, direction = "forward" }) => {
  const today = useMemo(() => dayjs().tz(TZ), []);
  const todayString = today.format("YYYY-MM-DD");
  const currentTab = activeTab || todayString;
  const isBackward = direction === "backward";

  const dateOptions = useMemo(() => {
    const options = [];

    if (!isBackward) {
      options.push({
        value: "live",
        label: "Kèo trực tuyến",
        shortLabel: "Live",
      });
    }

    options.push({
      value: todayString,
      label: "Hôm nay",
      shortLabel: "Hôm nay",
      dateLabel: today.format("DD/MM"),
    });

    if (isBackward) {
      const yesterday = today.clone().subtract(1, "day");
      options.push({
        value: yesterday.format("YYYY-MM-DD"),
        label: "Hôm qua",
        shortLabel: "Hôm qua",
        dateLabel: yesterday.format("DD/MM"),
      });

      for (let i = 2; i <= 7; i++) {
        const d = today.clone().subtract(i, "day");
        options.push({
          value: d.format("YYYY-MM-DD"),
          label: THU_VI[d.day()],
          shortLabel: THU_VI_SHORT[d.day()],
          dateLabel: d.format("DD/MM"),
        });
      }

      return options;
    }

    const tomorrow = today.clone().add(1, "day");
    options.push({
      value: tomorrow.format("YYYY-MM-DD"),
      label: "Ngày mai",
      shortLabel: "Ngày mai",
      dateLabel: tomorrow.format("DD/MM"),
    });

    for (let i = 2; i <= 6; i++) {
      const d = today.clone().add(i, "day");
      options.push({
        value: d.format("YYYY-MM-DD"),
        label: THU_VI[d.day()],
        shortLabel: THU_VI_SHORT[d.day()],
        dateLabel: d.format("DD/MM"),
      });
    }

    return options;
  }, [today, todayString, isBackward]);

  return (
    <div className="kbv-v26-date-tabs w-full min-w-0">
      <div className="kbv-v26-date-tabs-scroll">
        {dateOptions.map((opt) => {
          const isSelected = currentTab === opt.value;
          return (
            <button
              key={opt.value}
              type="button"
              aria-pressed={isSelected}
              onClick={() => onChange?.(opt.value)}
              className={`kbv-date-tab kbv-v26-date-tab ${
                isSelected ? "kbv-date-tab--selected" : "kbv-date-tab--unselected"
              }`}
            >
              <span className="kbv-v26-date-tab-label kbv-v26-date-tab-label--full">
                {opt.label}
              </span>
              <span className="kbv-v26-date-tab-label kbv-v26-date-tab-label--short">
                {opt.shortLabel}
              </span>
              {opt.dateLabel ? (
                <span className="kbv-date-label kbv-v26-date-tab-date">{opt.dateLabel}</span>
              ) : null}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default BoltDateTabs;
